import { Entity } from '@backstage/catalog-model';

export const DEFECT_DOJO_ANNOTATION = 'defectdojo.org/product-id';

export function getProductIdFromEntity(entity: Entity): number | null {
  const annotation =
    entity.metadata.annotations?.[DEFECT_DOJO_ANNOTATION];
  if (!annotation) return null;
  const parsed = parseInt(annotation, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

export function isDefectDojoAvailable(entity: Entity): boolean {
  return getProductIdFromEntity(entity) !== null;
}

export function isAnnotationInvalid(entity: Entity): boolean {
  const annotation =
    entity.metadata.annotations?.[DEFECT_DOJO_ANNOTATION];
  if (annotation === undefined) return false; // ausente não é inválido, é apenas ausente
  if (annotation.trim() === '') return true; // vazio é inválido
  const parsed = parseInt(annotation, 10);
  return Number.isNaN(parsed);
}
